<template>
  <div v-if="this.webShopOrder != null" class="container justify-content-center mt-5 webshop-payment-page">
    <div class="row d-flex justify-content-center">
      <div class="col-md-8 mt-5">
        <h3>
          {{ $t(LangConstants.your_order_summary_heading) }}
        </h3>
        <div class="row">
          <div class="col-md-12">
            <webshop-product-item :event="this.event" :title="product.name" :imgUrl="product.image ? product.image : ''" :subPeriod="this.paymentRecurringPeriod" :total="this.totalAmount" :description="product.description" :unitPrice="(this.unitPrice = !0 ? this.unitPrice : '')" :quantity="this.quantity"> </webshop-product-item>

            <div class="row">
              <div class="col-md-12">
                <div class="mt-5">
                  <my-button fa="bars" :label="$t(LangConstants.continue_button_label)" variant="solid-primary" classes="mr-1" height="56px" width="100%" type="submit" @onClick="payByCard"></my-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <stripe-checkout ref="checkoutRef" mode="subscription" :pk="publishableKey" :line-items="lineItems" :success-url="successURL" :cancel-url="cancelURL" :session-id="sessionId" @loading="(v) => (loading = v)" />
  </div>
</template>

<style lang="scss" scoped>
.webshop-payment-page {
  margin-top: 20px;
}
</style>

<script>
/**
 * Webshop Payment Page
 */
//import useValidate from "@vuelidate/core";
// import { required, email, requiredIf } from "vuelidate/lib/validators";
//import { reactive } from "@vue/composition-api";
import Common from "../../../../functions/index";
import Constants from "../../../../constants/index";

import WebshopProductItem from "../../../../components/atoms/WebshopProductItem.vue";
import "../../../../assets/scss/companypayment.scss";
import "../../../../assets/scss/stepper.scss";

import MyButton from "../../../../components/atoms/Button.vue";
// import MyInput from "../../../../components/atoms/Input.vue";
// import MyCheckbox from "../../../../components/atoms/Checkbox.vue";

// import CardLink from "../../../../components/atoms/CardLink.vue";

import { StripeCheckout } from "@vue-stripe/vue-stripe";

import { store } from "../../../../store/store";

// const dayjs = require("dayjs");

// const passwordMustBeValid = (value) => {
//   const re = new RegExp(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[-=_)(*^%$@!~`])[A-Za-z\d-=_)(*^%$@!~`]{6,}$/);
//   return re.test(value);
// };

export default {
  name: "webshop-payment",
  async beforeCreate() {},

  async created() {
    this.paymentId = this.$route.params.paymentId;
    this.instanceId = this.$route.params.instanceId;

    await this.$store
      .dispatch("getpendingWebshopPayment", {
        id: this.paymentId,
        instance_id: this.instanceId,
      })
      .then((wsp) => {
        wsp = wsp["data"];
        this.webShopOrder = wsp;
        this.product = wsp["course"];
        this.quantity = wsp["webshop_payment"]["quantity"];

        this.stripeCheckoutSessionPayload = {
          params: {
            mode: "payment",
            success_url: "",
            cancel_url: "",
            payment_intent_data: {
              application_fee_amount: 0,
              receipt_email: "",
            },
            line_items: [],
            automatic_tax: {
              enabled: true,
            },
            metadata: {
              //   form_firstName: this.stateStep2.firstName,
              //   form_lastName: this.stateStep2.lastName,
              //   form_registerEmail: this.stateStep2.registerEmail,
              //   form_phone: this.stateStep2.phone,
              //   form_sendmarketingemails: this.stateStep2.sendmarketingemails,
              //   form_courseid: this.$route.params.courseId,
              //   form_instance_id: this.$route.params.instanceId,
              //   form_userType: this.userType,
              //   form_organizationName: this.stateStep2.organizationName,
              //   form_organizationNumber: this.stateStep2.organizationNumber,
              //   product: null,
            },
          },
          options: {
            stripe_account: "",
          },
        };

        this.stripeInvoiceItemPayload = {
          customer: "",
          amount: "",
          currency: "",
          StripeAccount: "",
        };

        this.stripeInvoicePayload = {
          customer: "",
          application_fee_amount: "",
        };

        // await this.$store
        //   .dispatch("getWebshopCourse", {
        //     webshop_id: this.instanceId,
        //     course_id: this.courseId,
        //   })
        //   .then((result) => {
        //     let price = 0;
        //     this.unitPrice = Common.formatMoney(result.data.price, Common.toUpperCase(result.data.currency));
        //     this.courseName = result.data.course.name;
        //     this.event = result.data.course.course_event.find((e) => e.id == this.$route.query.event_id);
        //     this.selectedCourseType = result.data.course.type;
        //     this.isOrganizationDetailsEnabled = this.stateStep3.isActivated = this.selectedCourseType == "instructor_led_training";

        //     if (this.stateStep3.isActivated) {
        //       for (var i = 0; i < this.quantity; i++) {
        //         this.stateStep3.participants.push({
        //           firstName: null,
        //           lastName: null,
        //           phone: null,
        //           email: null,
        //           signupField: {
        //             name: "Dietery Exceptions",
        //             value: null,
        //           },
        //         });
        //       }
        //     }
        //     if (this.$route.query.quantity) {
        //       price = result.data.price * this.$route.query.quantity;
        //     } else {
        //       price = result.data.price;
        //     }

        //     this.product = {
        //       name: result.data.course.name,
        //       images: [result.data.course.image == null ? Common.getImagefromContext("placeholder") : result.data.course.image, ""],
        //       paymentRecurringPeriod: "month",
        //       description: result.data.course.summary,
        //       price: price,
        //       currency: result.data.currency,
        //     };

        this.productPricing = {
          recurring: { interval: "one-time" },
          currency: wsp["webshop_payment"]["currency"],
          unit_amount: wsp["webshop_payment"]["total"],
        };

        //     this.webshopId = result.data.id;

        this.stripeCheckoutSessionPayload.params.metadata.product = wsp["course"]["name"];

        this.stripeCheckoutSessionPayload.params.line_items.push({
          price_data: {
            tax_behavior: "inclusive",
            currency: wsp["webshop_payment"]["currency"],
            product_data: {
              name: this.product.name,
            },
            unit_amount: parseFloat(  (wsp["webshop_payment"]["total"] / wsp["webshop_payment"]["quantity"] )    ) * 100,
          },
          quantity: wsp["webshop_payment"]["quantity"],
        });

        this.stripeCheckoutSessionPayload.options.stripe_account = wsp["stripe_connect_active_account"]["account_id"];
        this.stripeCheckoutSessionPayload.params.success_url = store.getters.spInstanceVueURL + "company-account/webshop/purchase/abandonedsubscription/success/{CHECKOUT_SESSION_ID}/card/" + wsp["stripe_connect_active_account"]["account_id"];
        this.stripeCheckoutSessionPayload.params.cancel_url = store.getters.spInstanceVueURL + "company-account/webshop/purchase/abandonedsubscription/failed/{CHECKOUT_SESSION_ID}/card/" + wsp["stripe_connect_active_account"]["account_id"];

        this.stripeInvoiceItemPayload.amount = parseFloat(this.product.price) * 100;
        this.stripeInvoiceItemPayload.currency = this.product.currency;
        this.stripeInvoiceItemPayload.StripeAccount = wsp["stripe_connect_active_account"]["account_id"];
        this.stripeInvoicePayload.StripeAccount = wsp["stripe_connect_active_account"]["account_id"];
        // this.customerParams["stripe_account"] = result.data.customer.stripe_connect_active_account.account_id;
        
        // console.log(this.webshopOrder);

        this.$store
          .dispatch("getInstanceSettingsFiltered", {
            names: ["webshop_tranfer_fee_rate"],
            instance_id: this.$route.params.instanceId,
          })
          .then((result) => {

            this.applicationFeeRate = result.data.webshop_tranfer_fee_rate;
            const applicationFeeAmount = Common.calculateApplicationFee(this.applicationFeeRate, wsp["webshop_payment"]["total"]);

            this.stripeCheckoutSessionPayload.params.payment_intent_data.application_fee_amount = applicationFeeAmount;
            this.stripeInvoicePayload.application_fee_amount = applicationFeeAmount;
          });
      });




//  console.log(this.$store.state.currentAbandonedOrder);


  },
  setup() {
    return {
      loading: false,
      successURL: store.getters.spInstanceVueURL + "company-account/webshop/purchase/abandonedsubscription/success",
      cancelURL: store.getters.spInstanceVueURL + "company-account/webshop/purchase/abandonedsubscription/failed",
    };
  },
  data() {
    this.publishableKey = process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY;
    return {
      // priceSlug: null,
      // productSlug: null,
      lineItems: [
        {
          price: null, // The id of the recurring price you created in your Stripe dashboard
          quantity: 1,
        },
      ],
      // stateSignIn: {
      //   loginEmail: null,
      //   password: null,
      // },
      // stateStep2: {
      //   firstName: null,
      //   lastName: null,
      //   registerEmail: null,
      //   registerPassword: null,
      //   phone: null,
      //   organizationNumber: null,
      //   organizationName: null,
      //   sendmarketingemails: false,
      // },
      // stateStep3: {
      //   isActivated: false,
      //   groupName: null,
      //   participants: [],
      // },
      // currentStep: 1,
      // currentTab: "signup",
      // userData: {},
      product: [],
      stripeCheckoutSessionPayload: {},
      stripeInvoiceItemPayload: {},
      // customerParams: {},
      webshopId: null,
      stripeInvoicePayload: {},
      productPricing: null,
      unitPrice: "",
      quantity: 0,
      // cardPayment: null,
      // tabIndex: 0,
      sessionId: "",
      // userType: "new",
      // selectedCourseType: null,
      // isOrganizationDetailsEnabled: false,
      discountPercentage: 0,
      discountedPrice: 0,
      // courseId: null,
      instanceId: null,
      paymentId: null,
      // signInUser: {},
      // courseName: "",
      event: {},
      applicationFeeRate: 0,
      webShopOrder: null,
    };
  },

  methods: {
    // async proceedBtnHandler() {
    //   var validated = false;
    //   var userFormData = {};
    //   switch (this.currentStep) {
    //     case 1:
    //       this.incrementStep();
    //       break;
    //     case 2:
    //       if (this.tabIndex == 0) {
    //         this.$v.stateStep2.$touch();
    //         validated = !this.$v.stateStep2.$invalid;
    //         userFormData.username = this.stateStep2.registerEmail;
    //         userFormData.password = this.stateStep2.registerPassword;
    //       } else {
    //         this.$v.stateSignIn.$touch();
    //         validated = !this.$v.stateSignIn.$invalid;
    //         userFormData.username = this.stateSignIn.loginEmail;
    //         userFormData.password = this.stateSignIn.password;
    //       }

    //       if (validated == true) {
    //         this.$store
    //           .dispatch("loginWebShopUser", userFormData)
    //           .then((result) => {
    //             // Common.deleteFromLocalStorage(this.$route.params.id)
    //             if (this.tabIndex == 0) {
    //               if (result.response != 0) {
    //                 this.$fire({
    //                   title: this.$t(this.LangConstants.error_text),
    //                   text: this.$t(this.LangConstants.email_already_has_account),
    //                   type: "error",
    //                 });
    //               } else {
    //                 this.userType = "new";
    //                 this.moveToNextFromSecondStep();
    //               }
    //             } else {
    //               if (result.response == 1) {
    //                 this.$fire({
    //                   title: this.$t(this.LangConstants.error_text),
    //                   text: this.$t(this.LangConstants.invalid_credentials),
    //                   type: "error",
    //                 });
    //               } else if (result.response == 0) {
    //                 this.$fire({
    //                   title: this.$t(this.LangConstants.error_text),
    //                   text: this.$t(this.LangConstants.account_doesnot_exist),
    //                   type: "error",
    //                 });
    //               } else {
    //                 this.signInUser = {
    //                   userid: result.data.userid,
    //                   instance_id: this.instanceId,
    //                 };
    //                 this.userType = "old";
    //                 this.discountPercentage = 15; // TODO : Add discount price here

    //                 this.moveToNextFromSecondStep();
    //               }
    //             }
    //           })
    //           .catch((error) => {
    //             this.$fire({
    //               title: this.$t(this.LangConstants.error_text),
    //               text: this.$t(this.LangConstants.common_error_title),
    //               type: "error",
    //               html: "<div>" + this.$t(error) + "</div>",
    //             });
    //           });
    //       }

    //       break;

    //     case 3: {
    //       this.$v.stateStep3.$touch();
    //       if (!this.$v.stateStep3.$invalid) {
    //         let form = {
    //           courseid: this.courseId,
    //           instance_id: this.instanceId,
    //           users: this.stateStep3.participants,
    //         };

    //         this.$store.dispatch("courseAssignmentEnrolled", form).then((result) => {
    //           this.stateStep3.participants = result.data;
    //           let hasErrors = this.stateStep3.participants.some((e) => e.course_assigned == true);
    //           if (!hasErrors) {
    //             this.incrementStep();
    //           }
    //         });
    //       }
    //       break;
    //     }
    //   }
    // },

    async processLogin() {},

    async ProcessRegister() {},

    async payByCard() {

//       if (this.discountPercentage != 0) {
//         let total = this.product.price - this.discountedPrice;

// alert("total" + total);

//         this.stripeCheckoutSessionPayload.params.line_items[0].price_data.unit_amount = parseFloat(total) * 100;
//         this.stripeInvoiceItemPayload.amount = parseFloat(total) * 100;

//         const applicationFeeAmountWithDiscount = Common.calculateApplicationFee(this.applicationFeeRate, total);

//         this.stripeCheckoutSessionPayload.params.payment_intent_data.application_fee_amount = applicationFeeAmountWithDiscount;
//         this.stripeInvoicePayload.application_fee_amount = applicationFeeAmountWithDiscount;
//       }
      // this.stripeCheckoutSessionPayload.params.metadata.form_firstName = this.stateStep2.firstName;
      // this.stripeCheckoutSessionPayload.params.metadata.form_lastName = this.stateStep2.lastName;
      // this.stripeCheckoutSessionPayload.params.metadata.form_registerEmail = this.stateStep2.registerEmail;
      // this.stripeCheckoutSessionPayload.params.metadata.form_phone = this.stateStep2.phone;
      // this.stripeCheckoutSessionPayload.params.metadata.form_organizationName = this.stateStep2.organizationName;
      // this.stripeCheckoutSessionPayload.params.metadata.form_organizationNumber = this.stateStep2.organizationNumber;
      // this.stripeCheckoutSessionPayload.params.metadata.form_sendmarketingemails = this.stateStep2.sendmarketingemails;

      // console.log(this.$data.webshopOrder);

      this.stripeCheckoutSessionPayload.params.payment_intent_data.receipt_email = this.$store.state.currentAbandonedOrder["buyer"]["email"];
      this.stripeCheckoutSessionPayload.params.customer_email = this.$store.state.currentAbandonedOrder["buyer"]["email"];

      this.$store.dispatch("createStripeCheckout", this.stripeCheckoutSessionPayload).then((session) => {
        if (session.success == true) {
          this.sessionId = session.data.id;
          this.cacheFormData(session.data.id);
          window.location.href = session.data.url;
        } else {
          this.$fire({
            title: this.$t(Constants.common_error_title),
            text: this.$t(Constants.please_try_again_text),
            type: "error",
            html: "",
          });
        }
      });
    },

    // async handleInvoicePayment() {
    //   const prodType = this.selectedCourseType != null ? this.selectedCourseType : "";

    //   switch (prodType) {
    //     case "instructor_led_training":
    //       this.processInternalInvoice();
    //       break;
    //     default:
    //       this.processStripeInvoice();
    //       break;
    //   }
    // },

    async processInternalInvoice() {
      // Registerant/login data
      // Course and Event Data
      // Student Data
      // Payment Records Data ( Create new record );

      const id = Common.randomId();
      this.cacheFormData(id);

      this.$router.push({
        path: `/company-account/webshop/purchase/subscription/success/${id}/invoice_internal/null`,
        // params: {
        //   id: id,
        //   type: "invoice_internal",
        //   connectedAccount: null,
        // },
      });
    },

    // async processStripeInvoice() {
    //   this.customerParams.email = this.userType == "new" ? this.stateStep2.registerEmail : this.stateSignIn.loginEmail;

    //   await this.$store
    //     .dispatch("createStripeConnectedAccountCustomer", this.customerParams)
    //     .then((result) => {
    //       result = JSON.parse(JSON.stringify(result));

    //       let subscriptionParams = {
    //         customer: result["id"],
    //         "items[0][price]": "0",
    //         // "payment_settings[payment_method_types][]": "card",
    //         collection_method: "send_invoice",
    //         days_until_due: 30,

    //         "metadata[product]": this.product.name,

    //         "metadata[form_firstName]": this.stateStep2.firstName,
    //         "metadata[form_lastName]": this.stateStep2.lastName,
    //         "metadata[form_registerEmail]": this.stateStep2.registerEmail,
    //         "metadata[form_phone]": this.stateStep2.phone,
    //         "metadata[form_sendmarketingemails]": this.stateStep2.sendmarketingemails,
    //         "metadata[form_userType]": this.userType,
    //         "metadata[form_webshopId": this.webshopId,
    //       };

    //       if (this.userType == "new") {
    //         subscriptionParams["metadata[form_firstName]"] = this.stateStep2.firstName;
    //         subscriptionParams["metadata[form_lastName]"] = this.stateStep2.lastName;
    //         subscriptionParams["metadata[form_registerEmail]"] = this.stateStep2.registerEmail;
    //         subscriptionParams["metadata[form_phone]"] = this.stateStep2.phone;
    //         subscriptionParams["metadata[form_sendmarketingemails]"] = this.stateStep2.sendmarketingemails;
    //         subscriptionParams["metadata[form_userType]"] = this.stateStep2.userType;
    //       } else {
    //         subscriptionParams["metadata[form_registerEmail]"] = this.stateSignIn.loginEmail;
    //       }

    //       this.stripeInvoiceItemPayload.customer = result["id"];
    //       this.stripeInvoicePayload.customer = result["id"];

    //       this.$store
    //         .dispatch("createStripeInvoiceItem", this.stripeInvoiceItemPayload)
    //         .then((result) => {
    //           console.log(result);

    //           this.$store
    //             .dispatch("createStripeInvoice", this.stripeInvoicePayload)
    //             .then((result) => {
    //               this.$router.push({
    //                 name: "CompanyWebshopPaymentSuccess",
    //                 params: {
    //                   id: result.data.id,
    //                   type: "invoice",
    //                   connectedAccount: this.stripeInvoicePayload.StripeAccount,
    //                 },
    //               });
    //             })
    //             .catch((error) => {
    //               this.$fire({
    //                 title: this.$t(this.LangConstants.invoice_creation_status_heading),
    //                 text: this.$t(this.LangConstants.invoice_creation_failed_text),
    //                 type: "error",
    //                 html: "<div>" + this.$t(error) + "</div>",
    //                 timer: 3000,
    //               }).then(() => {
    //                 this.$router.push({ name: "CompanyWebshopPaymentFail" });
    //               });
    //             });
    //         })
    //         .catch((error) => {
    //           this.$fire({
    //             title: this.$t(this.LangConstants.invoice_creation_status_heading),
    //             text: this.$t(this.LangConstants.invoice_creation_failed_text),
    //             type: "error",
    //             html: "<div>" + this.$t(error) + "</div>",
    //             timer: 3000,
    //           }).then(() => {
    //             this.$router.push({ name: "CompanyWebshopPaymentFail" });
    //           });
    //         });
    //     })
    //     .catch((error) => {
    //       this.$fire({
    //         title: this.$t(this.LangConstants.invoice_creation_status_heading),
    //         text: this.$t(this.LangConstants.invoice_creation_failed_text),
    //         type: "error",
    //         html: "<div>" + this.$t(error) + "</div>",
    //         timer: 3000,
    //       }).then(() => {
    //         this.$router.push({ name: "CompanyWebshopPaymentFail" });
    //       });
    //     });
    // },

    cacheFormData(key) {
      let formData = {};

      // if (this.userType == "new") {
      formData = {
        // user: {
        //   first_name: this.stateStep2.firstName,
        //   last_name: this.stateStep2.lastName,
        //   email: this.stateStep2.registerEmail,
        //   password: this.stateStep2.registerPassword,
        //   phone: this.stateStep2.phone,
        //   receive_marketing_emails: this.stateStep2.sendmarketingemails,
        //   courseid: this.$route.params.courseId,
        //   instance_id: this.$route.params.instanceId,
        //   userType: this.userType,
        //   courseType: this.selectedCourseType,
        // },
        // participants: this.stateStep3.isActivated ? this.stateStep3.participants : [],
        // customer: {
        //   organization_number: this.stateStep2.organizationNumber,
        //   organization_name: this.stateStep2.organizationName,
        //   is_trusted: true // TODO Change this to work on values
        // },
        // group_name: this.stateStep3.isActivated ? this.stateStep3.groupName : null,
        instance_id: this.$route.params.instanceId,
        webshop_payment_id: this.$store.state.currentAbandonedOrder["webshop_payment"]["id"],
        product: {
          webshopId: this.webshopId,
          amount: this.$store.state.currentAbandonedOrder["webshop_payment"]["total"],
          event_id: this.$store.state.currentAbandonedOrder["course_event"] ? this.$store.state.currentAbandonedOrder["course_event"]['id'] : null,
          quantity: this.$store.state.currentAbandonedOrder["webshop_payment"]["quantity"],
          unit_price:  this.$store.state.currentAbandonedOrder["webshop_payment"]["total"] / this.$store.state.currentAbandonedOrder["webshop_payment"]["quantity"],
          currency: this.$store.state.currentAbandonedOrder["webshop_payment"]["currency"],
          productName: this.$store.state.currentAbandonedOrder["course"]["name"],
        },
      };
      // } else {
      //   console.log(this.signInUser);
      //   formData = {
      //     user: {
      //       email: this.stateSignIn.loginEmail,
      //       password: this.stateSignIn.password,
      //       courseid: this.$route.params.courseId,
      //       instance_id: this.$route.params.instanceId,
      //       userType: this.userType,
      //       courseType: this.selectedCourseType,
      //       is_teamlead: this.signInUser?.role_assignment?.find(role => role.roleid == Constants.teamlead) ? true : false
      //     },
      //     participants: this.stateStep3.isActivated ? this.stateStep3.participants : [],
      //     customer: {
      //       organization_number: "",
      //       organization_name: "",
      //       is_trusted: true // TODO Change this to work on values
      //     },
      //     group_name: this.stateStep3.isActivated ? this.stateStep3.groupName : null,
      //     product: {
      //       webshopId: this.webshopId,
      //       amount: this.product.price,
      //       discount_amount: this.discountedPrice,
      //       event_id: (this.event)? this.event.id : null,
      //       quantity: this.quantity,
      //       unitPrice: this.unitPrice,
      //       currency: this.product.currency,
      //       productName: this.product.name
      //     },
      //   };
      // }
      // console.log(formData);
      Common.setinLocalStorage(key, formData);
    },

    incrementStep() {
      // this.currentStep++;
      // this.$root.$emit("webshop-payment-wizard-step", this.currentStep);
    },

    // async moveToNextFromSecondStep() {
    //   if (this.stateStep3.isActivated) {
    //     if (this.stateStep3.participants.length == 1) {
    //       if (this.userType == "old") {
    //         await this.$store.dispatch("userGetFirst", this.signInUser).then((result) => {
    //           console.log(result);
    //           this.signInUser = result.data;
    //           console.log(this.signInUser?.role_assignment?.find(role => role.roleid == Constants.teamlead));
    //           this.$refs.pFirstName[0].text = this.stateStep3.participants[0].firstName = this.signInUser.first_name;
    //           this.$refs.pLastName[0].text = this.stateStep3.participants[0].lastName = this.signInUser.last_name;
    //           this.$refs.pEmail[0].text = this.stateStep3.participants[0].email = this.signInUser.email;
    //           this.$refs.pPhone[0].text = this.stateStep3.participants[0].phone = this.signInUser.phone;
    //         });
    //       } else if (this.userType == "new") {
    //         this.$refs.pFirstName[0].text = this.stateStep3.participants[0].firstName = this.stateStep2.firstName;
    //         this.$refs.pLastName[0].text = this.stateStep3.participants[0].lasstName = this.stateStep2.lastName;
    //         this.$refs.pEmail[0].text = this.stateStep3.participants[0].email = this.stateStep2.registerEmail;
    //         this.$refs.pPhone[0].text = this.stateStep3.participants[0].phone = this.stateStep2.phone;
    //       }
    //     } else {
    //       this.$refs.groupName.text = this.stateStep3.groupName = this.courseName + " - " + dayjs(this.event.start_date).format("DD-MM-YYYY");
    //     }
    //     this.incrementStep();
    //   } else {
    //     this.payByCard();
    //   }
    // },

    calculateDiscount() {
      this.discountedPrice = ((this.discountPercentage / 100) * this.product.price).toFixed(2);
    },

    getDefaultAmountValue() {
      let currency = this.productPricing != null && this.productPricing.currency ? Common.toUpperCase(this.productPricing.currency) : "";
      return "00.00 " + currency;
    },
  },
  computed: {
    webShopOrder_() {
      return this.webShopOrder;
    },
    customers() {
      return this.$store.getters.allCustomers;
    },

    totalAmount() {
      if (this.productPricing != null) {
        return Common.formatMoney(this.productPricing.unit_amount, Common.toUpperCase(this.productPricing.currency));
      }
      return this.getDefaultAmountValue();
    },
    paymentRecurringPeriod() {
      if (this.productPricing != null) {
        return this.productPricing.recurring ? Common.getIntervalByNoun(this.productPricing.recurring.interval) : "";
      }
      return "";
    },

    LangConstants() {
      return Constants;
    },

    marketingConsentHelperText() {
      return "(" + this.$t(Constants.marketing_consent_helper_text) + ")";
    },

    discountPrice() {
      if (this.discountPercentage != 0) {
        this.calculateDiscount();
        return Common.formatMoney(this.discountedPrice, Common.toUpperCase(this.productPricing.currency));
      }
      return this.getDefaultAmountValue();
    },

    totalAmountWithDiscount() {
      if (this.productPricing != null) {
        let total = this.productPricing.unit_amount - this.discountedPrice;
        return Common.formatMoney(total, Common.toUpperCase(this.productPricing.currency));
      }
      return this.getDefaultAmountValue();
    },
  },

  // validations: {
  //   stateSignIn: {
  //     loginEmail: { required, email },
  //     password: { required },
  //   },
  //   stateStep2: {
  //     firstName: { required },
  //     lastName: { required },
  //     registerEmail: { required, email },
  //     registerPassword: {
  //       required,
  //       passwordMustBeValid,
  //     },
  //     phone: { required },
  //     organizationNumber: {
  //       required: requiredIf(function() {
  //         return this.isOrganizationDetailsEnabled;
  //       }),
  //     },
  //     organizationName: {
  //       required: requiredIf(function() {
  //         return this.isOrganizationDetailsEnabled;
  //       }),
  //     },
  //   },
  //   stateStep3: {
  //     groupName: {
  //       required: requiredIf(function() {
  //         return this.stateStep3.isActivated && this.quantity > 1;
  //       }),
  //     },
  //     participants: {
  //       $each: {
  //         firstName: { required },
  //         lastName: { required },
  //         email: { required, email },
  //         phone: { required },
  //       },
  //     },
  //   },
  // },

  components: {
    WebshopProductItem,
    MyButton,
    // MyInput,
    // MyCheckbox,
    // CardLink,
    StripeCheckout,
  },
};
</script>
